export const CATEGORY = "CATEGORY";
